@import "@/styles/variables";

.sidebar {
	width: 290px;
	background: #ffffff;
	border-right: 1px solid $gray-200;
	display: flex;
	flex-direction: column;
	height: 100%;

	@media (max-width: 1024px) {
		width: 100%;
		border-right: none;
		border-bottom: 1px solid $gray-200;
		height: auto;
		max-height: 50vh;
		overflow-y: auto;
	}
}

.sidebarHeader {
	padding: 2rem 1.5rem 1.5rem;
	border-bottom: 1px solid $gray-100;

	@media (max-width: 1024px) {
		padding: 1.5rem 1rem;
	}
}

.sidebarHeaderTop {
	display: flex;
	align-items: flex-start;
	gap: 0.75rem;
}

.backButton {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border: none;
	border-radius: $border-radius;
	background-color: $gray-100;
	color: $gray-500;
	cursor: pointer;
	transition: all 0.2s ease;
	flex-shrink: 0;

	&:hover {
		background-color: $gray-200;
		color: $gray-700;
	}

	&:active {
		transform: scale(0.95);
	}
}

.sidebarTitle {
	font-size: 1.25rem;
	font-weight: 700;
	color: $gray-400;
	margin: 0 0 0.25rem 0;

	@media (max-width: 1024px) {
		font-size: 1.125rem;
	}
}

.sidebarSubtitle {
	font-size: 0.875rem;
	color: $gray-500;
	margin: 0;
}

.sidebarNav {
	flex: 1;
	padding: 1rem 0;

	@media (max-width: 1024px) {
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;
		padding: 1rem;
	}
}

.sidebarItem {
	width: 100%;
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.875rem 1.5rem;
	background: none;
	border: none;
	border-left: 3px solid transparent;
	cursor: pointer;
	transition: all 0.2s ease;
	text-align: left;

	@media (max-width: 1024px) {
		width: auto;
		flex: 1;
		min-width: calc(50% - 0.25rem);
		border-left: none;
		border-radius: $border-radius;
		padding: 0.75rem 1rem;
	}

	&:hover {
		background: $gray-50;
	}

	&.active {
		background: $primary-bg;
		border-left-color: $primary-color;

		@media (max-width: 1024px) {
			border-left: 2px solid $primary-color;
		}

		.sidebarItemIcon {
			background: $primary-color;
			color: #ffffff;
		}

		.sidebarItemTitle {
			color: $gray-700;
			font-weight: 600;
		}
	}
}

.sidebarItemIcon {
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: $gray-100;
	border-radius: 0.5rem;
	color: $gray-500;
	transition: all 0.2s ease;
}

.sidebarItemContent {
	flex: 1;
	min-width: 0;
}

.sidebarItemTitle {
	display: block;
	font-size: 0.9375rem;
	font-weight: 500;
	color: $gray-600;
	margin-bottom: 0.125rem;
}

.sidebarItemSubtitle {
	display: block;
	font-size: 0.75rem;
	color: $gray-400;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.sidebarItemBadge {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 24px;
	height: 24px;
	padding: 0 0.5rem;
	background: $gray-100;
	border-radius: 12px;
	font-size: 0.75rem;
	font-weight: 600;
	color: $gray-500;
}

.sidebarFooter {
	padding: 1rem 1.5rem 1.5rem;
	border-top: 1px solid $gray-100;

	@media (max-width: 1024px) {
		display: none;
	}
}

.helpCard {
	padding: 1rem;
	background: $primary-light;
	border-radius: 0.5rem;

	h3 {
		font-size: 0.875rem;
		font-weight: 600;
		color: $secondary-color;
		margin: 0 0 0.25rem 0;
	}

	p {
		font-size: 0.75rem;
		color: $primary-color;
		margin: 0 0 0.75rem 0;
	}
}

.helpLink {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	font-size: 0.75rem;
	font-weight: 600;
	color: $primary-color;
	text-decoration: none;
	transition: color 0.2s ease;

	&:hover {
		color: $primary-hover;
	}
}
